
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import FullLayout from "../layouts/FullLayout.jsx";
import Home from "../pages/home/Home.jsx";
import ContactUs from "../pages/contactUs/ContactUs.jsx";
import AboutUs from "../pages/aboutUs/AboutUs.jsx";
import Services from "../pages/services/Services.jsx";
import Pricing from "../pages/pricing/Pricing.jsx";
import Faqs from "../pages/faqs/Faqs.jsx";
import BasicInfo from "../pages/businessForm/BasicInfo.jsx";
import BusinessDetails from "../pages/businessForm/BusinessDetail.jsx";
import ServicesNeeded from "../pages/businessForm/ServicesNeeded.jsx";
import ClientScreening from "../pages/businessForm/ClientScreening.jsx";
import BusinessFormation from "../pages/businessForm/BusinessFormation.jsx";
import AdditionalDetails from "../pages/businessForm/AdditionalDetails.jsx";
import Terms from "../pages/cms/Terms.jsx";
import PrivacyPolicy from "../pages/cms/PrivacyPolicy.jsx";
import ScrollToTop from "../components/scrollToTop/ScrollToTop.jsx";
import BusinessAdvisory from "../pages/businessAdvisory/BusinessAdvisory.jsx";
import BusinessSupport from "../pages/businessSupport/BusinessSupport.jsx";
import Stripe from "../pages/stripePage/Stripe.jsx";
import Login from "../pages/login/Login.jsx";
import Signup from "../pages/signUp/SignUp.jsx";
import Dashboard from "../pages/Dashboard/Dashboard.jsx";
import User from "../pages/userManagement/Page.jsx";
import Quotation from "../pages/Quotation/Quotation.jsx";
import InvoiceManagement from "../pages/Invoice/InvoiceManagement.jsx";
import Setting from "../pages/Settings/Setting.jsx";

const AppRouter = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<FullLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/services" element={<Services />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/basic-info" element={<BasicInfo />} />
          <Route path="/business-details" element={<BusinessDetails />} />
          <Route path="/services-needed" element={<ServicesNeeded />} />
          <Route path="/additional-details" element={<AdditionalDetails />} />
          <Route path="/client-screening" element={<ClientScreening />} />
          <Route path="/business-formation" element={<BusinessFormation />} />
          <Route path="/business-advisory" element={<BusinessAdvisory />} />
          <Route path="/business-support" element={<BusinessSupport />} />
          <Route path="/stripe" element={<Stripe />} />
          <Route path="/login" element={<Login />} />
          <Route path="/sign-up" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/management" element={<User/>} />
          <Route path="/quotation" element={<Quotation/>} />
          <Route path="/invoice" element={<InvoiceManagement/>} />
          <Route path="/setting" element={<Setting/>} />


        </Route>
      </Routes>
    </Router>
  );
};

export default AppRouter;